import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getComplaintNotification = (params) => {
    console.log("Url",
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetComplaintNotification",
        params
    );
    return axiosGet(
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetComplaintNotification",
        params
    );
};

// const getComplaintNotification = (userId) => {
//     console.log("Url",
//         appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetComplaintNotification?userId=",
//         userId
//     );
//     return axiosGet(
//         appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetComplaintNotification?userId=",
//         userId
//     );
// };

const getCountNotification = (params) => {
    console.log("Url",
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetCountNotification",
        params
    );
    return axiosGet(
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetCountNotification",
        params
    );
};

const getComplaintGone = (params) => {
    console.log("Url",
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetComplaintGone",
        params
    );
    return axiosGet(
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/GetComplaintGone",
        params
    );
};

const readNotificationIssue = (
    userId, complaintId, departmentId, roleId, urlRedirect, title, provinceCode) => {

    console.log("Url",
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/ReadNotificationIssue?" +
        "userId=" + userId +
        "&complaintId=" + complaintId +
        "&roleId=" + roleId +
        "&departmentId=" + departmentId +
        "&urlRedirect=" + urlRedirect +
        "&title=" + title +
        "&provinceCode=" + provinceCode
    );
    return axiosPost(
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/ReadNotificationIssue?" +
        "userId=" + userId +
        "&complaintId=" + complaintId +
        "&roleId=" + roleId +
        "&departmentId=" + departmentId +
        "&urlRedirect=" + urlRedirect +
        "&title=" + title +
        "&provinceCode=" + provinceCode
    );
};

const readNotificationAll = (userId, roleId) => {
    console.log("Url",
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/ReadNotificationAll?" +
        "userId=" + userId +
        "&roleId=" + roleId
    );
    return axiosPost(
        appsettings.ocpbComplaintAPIUrl + "api/ComplaintNotification/ReadNotificationAll?" +
        "userId=" + userId +
        "&roleId=" + roleId
    );
};

export { 
    getComplaintNotification,
    getCountNotification,
    getComplaintGone,
    readNotificationIssue,
    readNotificationAll
}
